<template>
  <div class="addMessage">
    <div class="title">
      消息管理 <span>{{titlename}}消息</span>
    </div>
    <div class="main">
      <div class="addMessageInfo">{{titlename}}消息</div>
      <div class="messageContent">
        <div class="messagelist">
          <label for="imgTitle"><span></span>标题</label>
          <el-input size="small"
                    v-model="messageInfo.title"
                    placeholder="请输入"></el-input>
        </div>
        <div class="messagelist">
          <div class="messageBox">
            <div @click="type=0"
                 :class="{active:type ===0}">文本</div>
            <span>|</span>
            <div @click="type=1"
                 :class="{active:type === 1}">图片</div>
          </div>
          <label for="imgMessage"><span>*</span>消息内容</label>
          <el-input v-if="type===0"
                    type="textarea"
                    name="imgMessage"
                    :autosize="{ minRows: 3, maxRows: 8}"
                    placeholder="可输入10-1000个字符"
                    v-model="messageInfo.content"></el-input>
          <div class="imgItem"
               v-else-if="type===1">
            <div class="imgUrl">
              <img v-if="messageInfo.imgUrl"
                   :src="messageInfo.imgUrl"
                   class="avatar">
              <input type="file"
                     name="img"
                     id=""
                     @change="handleImgUpdate"
                     class="updateBtn"
                     accept="image/png,image/jpeg">
            </div>
          </div>
        </div>
        <div class="messagelist">
          <label for="imgTitle"><span>*</span>应用名称：</label>
          <el-checkbox-group class="appnameStyle"
                             v-model="checkboxGroup2"
                             size="medium">
            <el-checkbox-button v-for="(item,index) in appOptions"
                                :label="item"
                                :key="index">
              <p v-if="item === '0'">V货帮-货主端</p>
              <p v-else-if="item === '1'">V货帮-物流端</p>
              <p v-else-if="item === '2'">V货帮-司机端</p>
              <p v-else-if="item === '3'">V货帮-智能硬件</p>
            </el-checkbox-button>
          </el-checkbox-group>
        </div>
        <div class="messagelist">
          <label for="status">
            <span>*</span>数据状态
          </label>
          <div class='messageRadio'>
            <el-radio v-model="radio"
                      label="0">发布</el-radio>
            <el-radio v-model="radio"
                      label="1">草稿</el-radio>
          </div>
        </div>
        <div class="messageBtn">
          <button class="save"
                  @click="handleAddMessageClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { addMessage, updateMessage, messageList } from 'apis/index'
// import { mapState } from 'vuex'
export default {
  name: 'addmessage',
  data () {
    return {
      radio: '0',
      checkboxGroup2: [],
      titlename: '添加',
      type: 0,
      messageInfo: {
        id: '',
        imgUrl: 'http://img.zcool.cn/community/01528a58e4c8e6a801219c77b0154e.png@900w_1l_2o_100sh.jpg'

      },
      //   appOptions: [{
      //     value: '0',
      //     label: 'V货帮-货主端'
      //   },
      //   {
      //     value: '1',
      //     label: 'V货帮-物流端'
      //   },
      //   {
      //     value: '2',
      //     label: 'V货帮-司机端'
      //   }, {
      //     value: '3',
      //     label: 'V货帮-智能硬件'
      //   }]
      // }
      appOptions: ['0', '1', '2', '3']
    }
  },
  // computed: mapState({
  //   messageInfo: state => state.message.messageInfo
  // }),
  methods: {
    getData () {
      messageList({
        id: this.messageInfo.id
      }).then(res => {
        console.log(res)
        if (res.data.code === 200) {
          this.messageInfo = res.data.data.result[0]
          this.type = this.messageInfo.type
          this.radio = this.messageInfo.status
          this.checkboxGroup2 = this.messageInfo.appName.split(',')
        }
      })
    },
    handleCancelClick () { // 取消
      this.$router.push({ path: '/manage/message' })
    },

    handleAddMessageClick () { // 添加/修改
      let appname = ''
      this.checkboxGroup2.forEach(element => {
        appname += element + ','
      })
      appname = appname.substring(0, appname.length - 1)
      console.log(appname)
      if (this.type === 1) {
        console.log('图片')
        if (!this.messageInfo.size | !appname) {
          this.$message.error('*为必选内容')
        } else {
          if (this.messageInfo.id) {
            updateMessage({ // 图片修改消息
              id: this.messageInfo.id,
              title: this.messageInfo.title,
              imgUrl: this.messageInfo.imgUrl,
              size: this.messageInfo.size,
              suffix: this.messageInfo.suffix,
              appName: appname,
              status: this.radio,
              type: 1
            }).then(res => {
              if (res.data.code === 200) {
                this.$router.push({ path: '/manage/message' })
              }
            })
          } else {
            addMessage({ // 图片添加消息
              title: this.messageInfo.title,
              imgUrl: this.messageInfo.imgUrl,
              size: this.messageInfo.size,
              suffix: this.messageInfo.suffix,
              appName: appname,
              status: this.radio,
              type: 1
            }).then(res => {
              if (res.data.code === 200) {
                this.$router.push({ path: '/manage/message' })
              }
            })
          }
        }
      } else {
        if (!this.messageInfo.content | !appname) {
          this.$message.error('*为必选内容')
        } else {
          if (this.messageInfo.id) { // 文字修改消息
            updateMessage({
              id: this.messageInfo.id,
              title: this.messageInfo.title,
              content: this.messageInfo.content,
              appName: appname,
              status: this.radio,
              type: 0
            }).then(res => {
              if (res.data.code === 200) {
                this.$router.push({ path: '/manage/message' })
              }
            })
          } else {
            addMessage({ // 文字添加消息
              title: this.messageInfo.title,
              content: this.messageInfo.content,
              appName: appname,
              status: this.radio,
              type: 0
            }).then(res => {
              if (res.data.code === 200) {
                this.$router.push({ path: '/manage/message' })
              }
            })
          }
        }
      }
    },
    handleImgUpdate (e) { // 上传图片
      const MultipartFile = e.target.files[0]
      let param = new FormData()
      param.append('MultipartFile', MultipartFile)
      axios.post('/api/admin/upload.do', param).then(response => {
        this.messageInfo.imgUrl = response.data.url
        this.messageInfo.size = response.data.size
        this.messageInfo.suffix = response.data.subString
      })
    }
  },
  mounted () {
    this.messageInfo.id = this.$route.query.item
    if (!this.messageInfo.id) {
      this.messageInfo.title = '系统通知'
      this.titlename = '添加'
    } else {
      this.titlename = '修改'
      this.getData()
      // this.type = this.messageInfo.type
      // this.checkboxGroup2 = this.messageInfo.appName.split(',')
      // this.radio = this.messageInfo.status
    }
  }
}
</script>
<style lang="stylus">
.addMessage
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  z-index 1
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../assets/images/01/nav_arrow.png') no-repeat top 21px left 56px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .addMessageInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../assets/images/03/add_icon.png') no-repeat center left 15px
    .messageContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .messagelist
        margin-top 26px
        overflow hidden
        .messageBox
          width 200px
          height 30px
          margin-left 168px
          div, span
            color #5E656F
            float left
            margin 0 3px
            cursor pointer
            &.active
              color #1B88EE
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .appnameStyle
          margin-left 166px
          span
            color #212832
            border 1px solid #CFD5DC
            border-radius 3px
          label
            width auto
            margin-right 20px
          .el-checkbox-button.is-checked .el-checkbox-button__inner
            box-shadow none
            border-color #409EFF
            background url('../../assets/images/05/xuanzhong.png') no-repeat right bottom
          .el-checkbox-button__inner:hover
            color #409EFF
            border-color #409EFF
        .el-input
          width 220px
          margin-left 12px
        .el-textarea
          width 475px
          margin-left 12px
        .messageRadio
          height 30px
          .el-radio
            width 80px
            .el-radio__label
              color #212832
        .imgItem
          margin-left 168px
          width 172px
          position relative
          .imgUrl
            width 172px
            position relative
            height 130px
            img
              width 100%
              height 100%
            .updateBtn
              position absolute
              top 0px
              left 0px
              cursor pointer
              opacity 0
              right 0px
              bottom 0px
              overflow hidden
          .remark
            margin-top 20px
            color #5E656F
            background url('../../assets/images/07/tishi_icon_photo.png') no-repeat center left 5px
            text-indent 2em
            height 14px
            line-height 14px
      .messageBtn
        margin-left 116px
        margin-top 74px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
